export default function smartSticky(oggetto_sticky, elemento_blocco, elemento_sblocco) {
  document.onscroll = () => {
    // trovo elemento che interrompe il fixed
    const Posizione_Rottura = document.querySelector(elemento_blocco).offsetTop;

    // elemento fixed
    const Elemento_Fixed = document.querySelector(oggetto_sticky);

    // RILEVA IMPATTO
    const Posizione_show = document.querySelector(elemento_sblocco) ? document.querySelector(elemento_sblocco).getBoundingClientRect('html').top : false;


    if (Posizione_Rottura && Elemento_Fixed && Posizione_show) {
      // distanza dell'oggetto da top + distanza accumulata dallo scroll + altezza elemento
      const Posizione_Elemento = window.pageYOffset + document.querySelector(elemento_blocco).offsetTop + document.querySelector(elemento_blocco).clientHeight;

      //document.getElementById("result").textContent = Posizione_Elemento;

      if (Posizione_Elemento > Posizione_Rottura && (window.pageYOffset + window.innerHeight) > Posizione_Rottura) {
        Elemento_Fixed.style.position = 'absolute';
        Elemento_Fixed.style.bottom = '25px';
        Elemento_Fixed.style.right = '3px';
      }

      if ((window.pageYOffset + window.innerHeight) < Posizione_Rottura) {
        Elemento_Fixed.style.bottom = '25px';
        Elemento_Fixed.style.right = '10px';
        Elemento_Fixed.style.position = 'fixed';
      }

      if (Posizione_show < 20) {
        Elemento_Fixed.style.opacity = '0.9';
      } else {
        Elemento_Fixed.style.opacity = '0';
      }
    }
  };
}
